import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Input, Icon } from '../../../../../components';

const DataDictionarySearchContainer = styled.div`
  position: relative;
`;

const DataDictionarySearchInput = styled(Input)`
  height: 40px;
  background: var(--wash-gray-default);
  padding: 4px 38px;
  border-radius: 10px;
  box-sizing: border-box;
`;

const DataDictionarySearchInputIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  left: 9px;
`;

const DataDictionarySearch = ({ onChange }) => (
  <DataDictionarySearchContainer>
    <DataDictionarySearchInputIcon name='search' displaySize={20} color='var(--content-subtitle)' />
    <DataDictionarySearchInput
      placeholder='Search for fields...'
      onChange={(e) => onChange(e.target.value)}
    />
  </DataDictionarySearchContainer>
);

DataDictionarySearch.propTypes = {
  onChange: PropTypes.func.isRequired
};

export { DataDictionarySearch };
